module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_8.de7041b4.pdf";